import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["_title"]
const _hoisted_2 = {
  key: 0,
  icon: "exclamation-solid",
  color: "#D97706",
  size: "md",
  state: "rounded",
  "bg-color": "#FEF3C7"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("snap-modal", {
    onSnapModalClose: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
    _title: _ctx.title,
    prompt: ""
  }, [
    (_ctx.type == 'warning')
      ? (_openBlock(), _createElementBlock("snap-icon", _hoisted_2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.wideCloseButton)
      ? (_openBlock(), _createElementBlock("snap-button", {
          key: 1,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
          "full-width": "",
          size: "md",
          variant: "primary"
        }, "Continue"))
      : _createCommentVNode("", true)
  ], 40, _hoisted_1)), [
    [_vShow, _ctx.isOpened]
  ])
}